import { render } from "./AnnotationTool.vue?vue&type=template&id=76ab943a&scoped=true"
import script from "./AnnotationTool.vue?vue&type=script&lang=js"
export * from "./AnnotationTool.vue?vue&type=script&lang=js"

import "./AnnotationTool.vue?vue&type=style&index=0&id=76ab943a&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ab943a"]])

export default __exports__